module.exports = __webpack_public_path__ + "static/media/blood.9c610211.png";